export default __webpack_public_path__ + "static/media/BB.0bc6db9b.svg";